'use strict';

const SoaModel = require('bunsen/models/SoaModel');
const InvoiceSummary = module.exports = SoaModel.extend();

const root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

const _ = require('underscore');
const Backbone = require('dibs-backbone');
const Invoice = require('bunsen/models/ecomm/Invoice');

module.exports = root.bunsen.InvoiceSummary = InvoiceSummary;

_.extend(InvoiceSummary.prototype, {
    relations : SoaModel.createRelations([
        {
            type: Backbone.One,
            key: 'dealerCurrentInvoice',
            relatedModel: Invoice
        },
        {
            type: Backbone.Many,
            key: 'dealerDeltasInvoices',
            relatedModel: Invoice
        },
        {
            type: Backbone.One,
            key: 'dealerOriginalInvoice',
            relatedModel: Invoice
        }
    ])
});



// WEBPACK FOOTER //
// ./~/bunsen/models/ecomm/InvoiceSummary.es.js